import { notificationsInitState } from '@/utils'
import { httpAuthRequest } from '@/services'

const state = notificationsInitState()

const actions = {
    async getNotifications({ commit }) {
        const response = await httpAuthRequest('get', '/notifications/')
        if (response.success) commit('SET_NOTIFICATIONS', response.data.results)
    },

    async markAllAsRead({ commit }, payload) {
        const response = await httpAuthRequest('put', '/notifications/mark-all-read/', payload)
        if (response.success) {
            commit('SET_ALL_READ')
        }
        return response
    },

}

const mutations = {

    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },

    SET_ALL_READ(state) {
        for (state of state.notifications) {
            state.unread = false
        }
    },

    RESET_STATE(state) {
        Object.assign(state, notificationsInitState())
    }
}

export default {
    state,
    actions,
    mutations
}
